import React, { useCallback } from "react";
import { Box, Button, Grid, IconButton } from "@material-ui/core";
import { InputFieldFormik } from "ui/componentes/Form/InputFieldFormik";
import { Delete } from "@material-ui/icons";
import { FieldArray, Form, Formik } from "formik";
import { PointsByRaceConfiguration } from "api/model/PointsByRaceConfiguration";
import { Collections, useOnSubmitFormik } from "api";
import * as Yup from "yup";
import { SubmitButton, yupRequiredField } from "ui/componentes";

export const PointsByRaceFormValidation = Yup.object().shape({
    pointsByPositions: Yup.array().of(
        Yup.object().shape({
            position: Yup.number().required(yupRequiredField),
            points: Yup.number().required(yupRequiredField),
        })
    ),
});

const PointsByPositionList = ({ pointsByRace }) => {
    const onSubmit = useOnSubmitFormik<PointsByRaceConfiguration>(
        Collections.POINTS_BY_RACE_CONFIG,
        {
            beforeSubmit: (config) => {
                config.pointsByPositions = config.pointsByPositions.filter(
                    (pointsByPosition) =>
                        pointsByPosition.points && pointsByPosition.position
                );
            },
        }
    );
    const addPoinstByPosition = useCallback((push, position) => {
        return () => {
            push({ position, points: "" });
        };
    }, []);

    return (
        <Formik
            enableReinitialize={true}
            initialValues={pointsByRace}
            onSubmit={onSubmit}
            validationSchema={PointsByRaceFormValidation}
        >
            {({ values, errors }) => {
                return (
                    <Form>
                        <FieldArray name="pointsByPositions">
                            {({ push, remove }) => {
                                if (values.pointsByPositions.length === 0) {
                                    return (
                                        <Grid item xs={3}>
                                            <Button
                                                color="primary"
                                                onClick={addPoinstByPosition(
                                                    push,
                                                    1
                                                )}
                                            >
                                                Adicionar pontuação
                                            </Button>
                                        </Grid>
                                    );
                                }
                                return values.pointsByPositions.map(
                                    (pointsByPosition, index) => {
                                        const isLast =
                                            index ===
                                            values.pointsByPositions.length - 1;
                                        return (
                                            <Grid item xs={12} key={index}>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={3}>
                                                        <InputFieldFormik
                                                            id={`pointsByPositions.${index}.position`}
                                                            name={`pointsByPositions.${index}.position`}
                                                            label="Posição"
                                                            type="number"
                                                        />
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <InputFieldFormik
                                                            id={`pointsByPositions.${index}.points`}
                                                            name={`pointsByPositions.${index}.points`}
                                                            label="Pontos"
                                                            type="number"
                                                            autoFocus
                                                            onKeyUp={(
                                                                event
                                                            ) => {
                                                                if (
                                                                    event.keyCode ===
                                                                        13 &&
                                                                    !errors[
                                                                        "pointsByPositions"
                                                                    ]
                                                                ) {
                                                                    setTimeout(
                                                                        () => {
                                                                            addPoinstByPosition(
                                                                                push,
                                                                                pointsByPosition.position +
                                                                                    1
                                                                            )();
                                                                        },
                                                                        300
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={1}>
                                                        <IconButton
                                                            color="secondary"
                                                            onClick={() => {
                                                                remove(index);
                                                            }}
                                                        >
                                                            <Delete />
                                                        </IconButton>
                                                    </Grid>
                                                    <Grid item xs={5} />
                                                    {isLast && (
                                                        <Grid item xs={6}>
                                                            <Box display="flex">
                                                                <SubmitButton
                                                                    greenColor
                                                                >
                                                                    Salvar
                                                                </SubmitButton>
                                                            </Box>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        );
                                    }
                                );
                            }}
                        </FieldArray>
                    </Form>
                );
            }}
        </Formik>
    );
};

export { PointsByPositionList };
